import { ChevronLeft, ChevronRight } from 'lucide-react';
import Dropdown from './Dropdown';

const Pagination = ({
    currentPage,
    totalPages,
    onPageChange,
    entriesPerPage,
    entriesHandler,
    textActive = 'text-white',
    currentColor = 'bg-[#081B17]',
    hoverColor = 'hover:text-tsPrimary',
    className = '',
    border = 'border-[#626262]',
    hoverBorder = 'hover:border-[#626262]',
    totalEntries,
}) => {
    const maxPagesToShow = 6;
    const pageNumbers = [];

    if (totalPages <= maxPagesToShow) {
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(i);
        }
    } else {
        pageNumbers.push(1);
        if (currentPage > 3) pageNumbers.push('...');

        let start = Math.max(2, currentPage - 1);
        let end = Math.min(totalPages - 1, currentPage + 1);

        for (let i = start; i <= end; i++) {
            pageNumbers.push(i);
        }

        if (currentPage < totalPages - 2) pageNumbers.push('...');
        pageNumbers.push(totalPages);
    }

    return (
        <div className={`flex items-center justify-between p-4 ${className} `}>
            <div className={`flex items-center justify-center space-x-2  ${textActive} `}>
                <button
                    className={`px-3 py-1 rounded-md  ${hoverColor} ${currentPage === 1 ? `opacity-50 cursor-not-allowed ${textActive} ` : 'text-textSecondary'
                        }`}
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                >
                    <ChevronLeft size={14} />
                </button>

                {pageNumbers.map((page, index) => (
                    <button
                        key={index}
                        className={`px-3  py-1   rounded-[.25rem]
            
                ${page === '...'
                                ? 'cursor-default'
                                : page === currentPage
                                    ? ` ${currentColor}  ${textActive} border ${border}  `
                                    : `bg-transparent  border border-borderUnderline    text-textSecondary ${hoverColor} `
                            }`}
                        disabled={page === '...'}
                        onClick={() => typeof page === 'number' && onPageChange(page)}
                    >
                        {page}
                    </button>
                ))}

                <button
                    className={`px-3 py-1 rounded-md ${hoverColor}  ${currentPage === totalPages ? `opacity-50 cursor-not-allowed ${textActive} ` : 'text-textSecondary'
                        }`}
                    disabled={currentPage === totalPages}
                    onClick={() => onPageChange(currentPage + 1)}
                >
                    <ChevronRight size={14} />
                </button>
            </div>

            <div className="flex flex-col md:flex-row md:items-center  gap-2">
                <div className="flex gap-2 items-center justify-between">
                    <p className="text-textSecondary">Showing </p>
                    <div className="relative ">
                        <Dropdown
                            modifyLabel={(listItem) => {
                                return (
                                    <div className="flex items-center gap-5 text-[#A3A3A3]">
                                        <span>{listItem} </span>
                                    </div>
                                );
                            }}
                            data={[10, 20, 30]}
                            modifySelected={(selected) => {
                                console.log(selected, 'see the selected');
                                return (
                                    <div className="flex items-center gap-5">
                                        <span className={`text-tsPrimary`}>{selected}</span>
                                    </div>
                                );
                            }}
                            selected={entriesPerPage}
                            onSelected={(val) => {
                                entriesHandler(val);
                            }}
                            noSelectedText="10"
                            //   btnClass="rounded-e-none"
                            w=" w-[71px]"
                        />
                    </div>
                </div>

                <p className="text-textSecondary"> of {totalEntries || totalPages * entriesPerPage} items</p>
            </div>
        </div>
    );
};

export default Pagination;
